import * as consts from './MapConsts';

const initialState = {
    location: {
        lat: 0,
        lon: 0
    },
    info: {
        zoom: 0,
        type: 'roadmap',
        defaultStreetView: false
    },
    showMap: false,
    geocoderDataFullfilled: false,
    geocoderError: ''
};

const map = (state = initialState, action) => {
    switch (action.type) {
        case consts.GET_COORDINATES_PENDING:
            return {
                ...state
            }
        case consts.GET_COORDINATES_FULFILLED:
            return {
                ...state,
                location: action.payload.location,
                geocoderDataFullfilled: action.payload.geocoderDataFullfilled
            }
        case consts.GET_COORDINATES_REJECTED:
            return {
                ...state,
                geocoderError: action.payload,
                showMap: false
            }
        default:
            return state
    }
}

export default map;
